import React, { useEffect, useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import API_BASE from "../config/api";

function Navbar() {
    const [user, setUser] = useState(null);
    const navigate = useNavigate();

    useEffect(() => {
        const saved = localStorage.getItem("user");
        if (saved) setUser(JSON.parse(saved));
    }, []);

    const handleLogout = () => {
        console.log("LOGOUT CLICKED");   // 🔥 ADD THIS
        localStorage.removeItem("user");
        window.location.href = "/";       // full reload
    };

    const [show, setShow] = useState(false);
    const [agents, setAgents] = useState([]);
    const [selectedAgent, setSelectedAgent] = useState(null);
    const [loading, setLoading] = useState(false);
    const [mobile, setMobile] = useState("");
    const [callStep, setCallStep] = useState(1);
    const [businessName, setBusinessName] = useState("");


    useEffect(() => {
        fetchAgents();
    }, []);

    const fetchAgents = async () => {
        setLoading(true);
        try {
            const res = await fetch(`${API_BASE}/api/support-agents.php`);
            const data = await res.json();
            if (data.success && Array.isArray(data.data)) {
                setAgents(data.data);
            }
        } catch (e) {
            console.error(e);
        } finally {
            setLoading(false);
        }
    };
    const getFallbackImage = (gender) => {
        return gender === "male"
            ? "/call_center_male.jpg"
            : "/Call_center_female.jpg";
    };

    const [country, setCountry] = useState({
        code: "+977",
        flag: "🇳🇵",
        maxLength: 10
    });
    const CancelBtn = () => (
        <button
            className="btn btn-outline-secondary w-100 mt-2"
            onClick={closeModal}
        >
            Cancel
        </button>
    );

    const openModal = () => {
        if (agents.length > 0) {
            const random = agents[Math.floor(Math.random() * agents.length)];
            setSelectedAgent(random);
        }
        setMobile("");
        setBusinessName("");
        setCallStep(1);   // ✅ RESET FLOW
        setShow(true);
    };


    const closeModal = () => setShow(false);

    return (
        <>
            <nav className="navbar navbar-expand-lg bg-white shadow-sm py-3 sticky-top">
                <div className="container">

                    {/* Logo */}
                    <Link to="/" className="navbar-brand d-flex align-items-center">
                        <img
                            src="/logo.png"
                            alt="Dial Nepal Logo"
                            style={{ width: "160px", marginRight: "49px" }}
                        />
                    </Link>

                    {/* Mobile Toggle */}
                    <button
                        className="navbar-toggler"
                        type="button"
                        data-bs-toggle="collapse"
                        data-bs-target="#mainNavbar"
                    >
                        <span className="navbar-toggler-icon"></span>
                    </button>

                    <div className="collapse navbar-collapse" id="mainNavbar">

                        {/* CENTER MENU */}
                        <ul className="navbar-nav mx-auto mb-2 mb-lg-0 pl-2">
                            <li className="nav-item px-2">
                                <Link className="nav-link fw-semibold text-dark" style={{ fontSize: "17px" }} to="/">Home</Link>
                            </li>

                            <li className="nav-item px-2">
                                <Link
                                    className="nav-link fw-semibold text-dark position-relative"
                                    style={{ fontSize: "17px" }}
                                    to="/#"
                                >
                                    Leads

                                    {/* 🔴 Red Dot (very close) */}
                                    <span
                                        style={{
                                            width: "7px",
                                            height: "7px",
                                            background: "red",
                                            borderRadius: "50%",
                                            position: "absolute",
                                            top: "5px",
                                            right: "1px"   // ← moved VERY close
                                        }}
                                    ></span>
                                </Link>
                            </li>



                            <li className="nav-item px-2">
                                <Link className="nav-link fw-semibold text-dark" style={{ fontSize: "17px" }} to="/#">Advertise</Link>
                            </li>

                            <li className="nav-item px-2">
                                <Link className="nav-link fw-semibold text-dark" style={{ fontSize: "17px" }} to="/#">Become An Agent</Link>
                            </li>
                        </ul>



                        {/* RIGHT SIDE BUTTONS */}
                        <div className="d-flex align-items-center gap-2 ms-lg-3 mt-3 mt-lg-0">

                            {/* 1️⃣ Free Listing Button */}
                            <Link to="/add-listing" className="fb btn  px-3 d-flex align-items-center" style={{
                                backgroundColor: "#0076d7",   // faint blue
                                color: "#ffffff",             // white text
                                border: "1px solid #6ea8fe"
                            }}>
                                <i className="bi bi-plus-lg me-1"></i>
                                Free Listing

                                {/* 🏷️ Small Tag Badge like JD business name */}
                                <span className="badge bg-warning text-dark ms-2" style={{ fontSize: "10px" }}>
                                    New
                                </span>
                            </Link>


                            {/* BUTTON */}
                            <button
                                className="btn btn-success px-3"
                                onClick={openModal}
                            >
                                <i className="bi bi-telephone-fill me-1"></i>
                                Talk to Us
                            </button>

                            {/* MODAL */}
                            {show && (
                                <div
                                    className="modal fade show"
                                    style={{ display: "block", background: "rgba(0,0,0,.5)" }}
                                >
                                    <div className="modal-dialog modal-dialog-centered">
                                        <div className="modal-content" style={{ borderRadius: 6 }}>
                                            {/* HEADER */}
                                            <div
                                                className="text-white text-center p-3"
                                                style={{
                                                    background: "linear-gradient(135deg,#4C6EF5,#15AABF)",
                                                    borderTopLeftRadius: 6,   // ✅ curve top-left
                                                    borderTopRightRadius: 6,  // ✅ curve top-right
                                                }}
                                            >
                                                <h5 className="mb-0">
                                                    Talk to Our Support Expert
                                                </h5>
                                            </div>

                                            {/* BODY */}
                                            <div className="p-4 text-center">

                                                {/* ================= STEP 1 ================= */}
                                                {callStep === 1 && selectedAgent && (
                                                    <>
                                                        <img
                                                            src={selectedAgent?.photo || getFallbackImage(selectedAgent?.gender)}
                                                            onError={(e) => {
                                                                e.currentTarget.onerror = null;
                                                                e.currentTarget.src = getFallbackImage(selectedAgent?.gender);
                                                            }}
                                                            className="agent-avatar mb-3"
                                                            alt={selectedAgent?.name}
                                                        />


                                                        <h6 className="fw-bold mb-1">
                                                            {selectedAgent.name} will assist you
                                                        </h6>

                                                        <small className="text-muted">
                                                            Get on a voice call now
                                                        </small>

                                                        <div className="input-group my-3">

                                                            <select
                                                                className="form-select"
                                                                style={{ maxWidth: "110px" }}
                                                                value={country.code}
                                                                onChange={(e) => {
                                                                    const val = e.target.value;

                                                                    if (val === "+977") setCountry({ code: "+977", maxLength: 10 });
                                                                    if (val === "+91") setCountry({ code: "+91", maxLength: 10 });
                                                                    if (val === "+1") setCountry({ code: "+1", maxLength: 10 });
                                                                }}
                                                            >
                                                                <option value="+977">🇳🇵 +977</option>
                                                                <option value="+91">🇮🇳 +91</option>
                                                                <option value="+1">🇺🇸 +1</option>
                                                            </select>

                                                            <input
                                                                type="text"
                                                                className="form-control"
                                                                placeholder="Mobile number"
                                                                maxLength={country.maxLength}
                                                                value={mobile}
                                                                onChange={(e) =>
                                                                    setMobile(e.target.value.replace(/\D/g, ""))
                                                                }
                                                            />
                                                        </div>



                                                        <button
                                                            className="btn jd-call-btn w-100"
                                                            onClick={() => {
                                                                if (mobile.length !== country.maxLength)

                                                                    return alert("Enter valid 10 digit mobile number");

                                                                setCallStep(2);
                                                                setTimeout(() => setCallStep(3), 3000);
                                                            }}
                                                        >
                                                            Call Now
                                                        </button>
                                                        <CancelBtn />
                                                    </>
                                                )}

                                                {/* ================= STEP 2 ================= */}
                                                {callStep === 2 && (
                                                    <>
                                                        <h6 className="mb-3">📞 Incoming voice call</h6>

                                                        <img
                                                            src={selectedAgent?.photo || getFallbackImage(selectedAgent?.gender)}
                                                            onError={(e) => {
                                                                e.currentTarget.onerror = null; // prevent loop
                                                                e.currentTarget.src = getFallbackImage(selectedAgent?.gender);
                                                            }}
                                                            className="agent-avatar mb-3"
                                                            alt={selectedAgent?.name}
                                                        />

                                                        <p className="text-primary fw-semibold">
                                                            Connecting {selectedAgent?.name}...
                                                        </p>
                                                        <CancelBtn />
                                                    </>
                                                )}

                                                {/* ================= STEP 3 ================= */}
                                                {callStep === 3 && (
                                                    <>
                                                        <h6 className="text-danger mb-2">Agent Busy</h6>

                                                        <p className="small">
                                                            All our advisors are currently busy.<br />
                                                            We will call you back shortly on <b>{mobile}</b>
                                                        </p>

                                                        <input
                                                            className="form-control my-3"
                                                            placeholder="Enter Business Name"
                                                            value={businessName}
                                                            onChange={(e) => setBusinessName(e.target.value)}
                                                        />

                                                        <button
                                                            className="btn btn-success w-100"
                                                            onClick={() => {
                                                                if (!businessName)
                                                                    return alert("Enter business name");
                                                                setCallStep(4);
                                                            }}
                                                        >
                                                            Submit
                                                        </button>
                                                        <CancelBtn />
                                                    </>
                                                )}

                                                {/* ================= STEP 4 ================= */}
                                                {callStep === 4 && (
                                                    <>
                                                        <div className="text-success fs-1 mb-2">✔</div>

                                                        <h6>Thank you for sharing your business name</h6>

                                                        <p className="small">
                                                            We will call you back shortly on <b>{mobile}</b>
                                                        </p>

                                                        <button
                                                            className="btn btn-outline-secondary w-100"
                                                            onClick={closeModal}
                                                        >
                                                            Close
                                                        </button>
                                                        <CancelBtn />
                                                    </>
                                                )}

                                            </div>

                                        </div>
                                    </div>
                                </div>
                            )}




                            {/* BEFORE LOGIN → Show Login Button */}
                            {!user && (
                                <Link to="/login" className="btn btn-outline-primary px-3">
                                    <i className="bi bi-box-arrow-in-right me-1"></i>
                                    Login
                                </Link>
                            )}

                            {/* AFTER LOGIN */}
                            {user && (
                                <div className="dropdown">
                                    <button
                                        className="user-btn dropdown-toggle"
                                        data-bs-toggle="dropdown"
                                    >
                                        <i className="bi bi-person-circle me-2"></i>
                                        {user.fullname}
                                    </button>

                                    <ul className="dropdown-menu dropdown-menu-end shadow-sm">
                                        <li>
                                            <span className="dropdown-item-text small text-muted">
                                                Welcome
                                            </span>
                                        </li>

                                        <li>
                                            <span className="dropdown-item-text fw-semibold">
                                                {user.fullname}
                                            </span>
                                        </li>

                                        <li><hr className="dropdown-divider" /></li>

                                        <li>
                                            <Link
                                                className="dropdown-item"
                                                to={`/admin?userid=${user.personaluid}`}
                                            >
                                                <i className="bi bi-grid me-2"></i>
                                                Admin Panel
                                            </Link>
                                        </li>

                                        <li>
                                            <button
                                                className="dropdown-item text-danger"
                                                onClick={handleLogout}
                                            >
                                                <i className="bi bi-box-arrow-right me-2"></i>
                                                Logout
                                            </button>
                                        </li>
                                    </ul>
                                </div>
                            )}
                        </div>

                    </div>
                </div>
            </nav>

            {/* Internal CSS */}
            <style>{`
                .nav-text {
                    font-size: 15px;
                    font-weight: 500;
                    margin-right: 20px;
                }

                .nav-link:hover {
                    color: #0d6efd !important;
                }
            `}</style>
            <style>{`
                .dropdown-menu {
                    border-radius: 8px;
                }

                .dropdown-item:hover {
                    background: #f2f5ff;
                }

                .btn-light {
                    background: #fff;
                    border-radius: 6px;
                }
                    .user-btn {
                    background: transparent !important;
                    border: none !important;
                    outline: none !important;
                    box-shadow: none !important;
                    padding: 6px 12px;
                    display: flex;
                    align-items: center;
                    color: var(--bs-primary) !important;
                    font-weight: 500;
                }

                .user-btn i {
                    color: var(--bs-primary) !important;
                }

                /* Remove grey/blue hover & active effects */
                .user-btn:hover,
                .user-btn:focus,
                .user-btn:active,
                .user-btn.show {
                    background: transparent !important;
                    border: none !important;
                    outline: none !important;
                    box-shadow: none !important;
                    color: var(--bs-primary) !important;
                }
                    /* GLOBAL FONT SETTINGS */
body, .navbar, .nav-link, .dropdown-menu, .btn {
    font-family: "Poppins", sans-serif !important;
    font-size: 14px !important;
    font-weight: 400 !important;
    color: #000 !important;
}
.fb{

color: #fff !important; }

/* NAV ITEMS SMALL + RIGHT ALIGN */
#mainNavbar .navbar-nav {
    margin-left: auto !important;  /* ← moves all 4 nav items to RIGHT */
    margin-right: 0 !important;
}

/* Reduce gap between items slightly */
#mainNavbar .nav-item {
    padding-left: 6px !important;   /* reduced from px-2 */
    padding-right: 6px !important;
}

/* BUTTONS SMALL LIKE JustDial */
.navbar .btn {
    padding: 4px 10px !important;
    font-size: 13px !important;
    border-radius: 6px !important;
}

/* Free Listing button small badge */
.navbar .badge {
    font-size: 8px !important;
    padding: 2px 4px !important;
}

/* Logo gap reduce */
.navbar-brand img {
    margin-right: 20px !important;
}

/* Talk to us icon spacing reduce */
.btn i {
    margin-right: 4px !important;
}
/* ===== JUSTDIAL TALK TO US ===== */

.jd-phone-box {
    display: flex;
    align-items: center;
    border: 1px solid #e5e7eb;
    border-radius: 8px;
    padding: 8px 10px;
    background: #fafafa;
}

.jd-flag {
    font-size: 18px;
    margin-right: 6px;
}

.jd-code {
    font-size: 13px;
    color: #555;
    margin-right: 8px;
}

.jd-phone-input {
    border: none;
    outline: none;
    flex: 1;
    font-size: 14px;
    background: transparent;
}

.jd-call-btn {
    background: #16a34a;
    color: #fff;
    border-radius: 8px;
    padding: 10px;
    font-size: 14px;
}

.jd-call-btn:hover {
    background: #15803d;
}

/* Modal faint look */
.modal-content {
    border: none !important;
    box-shadow: 0 12px 30px rgba(0,0,0,.12);
}

.modal-body small {
    color: #6b7280;
}
.agent-avatar {
    width: 72px;
    height: 72px;
    border-radius: 6px;   /* ✅ exactly as requested */
    object-fit: cover;
    border: 1px solid #e5e7eb;
    background: #f8fafc;
}



            `}</style>

        </>
    );
}

export default Navbar;
